import request from '@/utils/request'

export function getPackageCategoryApi(query) {
  return request({
    url: '/config-service/v1/package-category',
    method: 'get',
    params: query
  })
}

export function addPackageCategoryApi(query) {
  return request({
    url: '/config-service/v1/package-category',
    method: 'post',
    data: query
  })
}

export function updatePackageCategoryApi(query) {
  return request({
    url: '/config-service/v1/package-category',
    method: 'put',
    data: query
  })
}
export function deletePackageCategoryApi(query) {
  return request({
    url: '/config-service/v1/package-category',
    method: 'delete',
    data: query
  })
}
